var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgElephant(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 114.96 84.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#50c1dc;}.cls-2{fill:#33b2d3;}.cls-11,.cls-13,.cls-2,.cls-4{isolation:isolate;}.cls-3{fill:#243a78;}.cls-4{fill:#1e2c5a;}.cls-5{fill:#89dae8;}.cls-11,.cls-13,.cls-6{fill:#072256;}.cls-7{fill:#19417e;}.cls-8{fill:#c9e8f0;}.cls-9{fill:none;stroke:#f7e1e1;stroke-miterlimit:10;stroke-width:0.28px;}.cls-10,.cls-11{opacity:0.2;}.cls-12,.cls-13{opacity:0.1;}.cls-14{fill:#cbeaf2;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.33,11.25S28.24-3,13.11,2.23-4.92,37.53,9,49.46,41.08,46.4,41.08,46.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M36.84,10.43S21.82,29.37,20.54,54a26.48,26.48,0,0,0,10.33-1.88A13.71,13.71,0,0,0,35,49.4C40.12,44.38,36.84,10.43,36.84,10.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M38.85,17.85s-11-13.31-23.06-9.16S1.14,35.51,12.23,45s28.45-3.79,28.45-3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M34.53,13.69C30.7,19.46,23.27,32.4,21.08,48.43c6.1.27,12.32-2.68,16.07-4.89,1.22-7.6.65-20.08.15-27.36A36.63,36.63,0,0,0,34.53,13.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.63,11.25S86.72-3,101.85,2.23s18,35.3,4.12,47.23S73.88,46.4,73.88,46.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M76.11,17.85s11-13.31,23.06-9.16S113.82,35.51,102.73,45s-28.45-3.79-28.45-3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M83.51,33C85.11,2.38,64.16,0,57.51,0h-.06c-6.65,0-27.61,2.38-26,33,0,0-9.9,7.63-4.89,17C32.25,60.5,51.34,62,56.76,62.26v0l.72,0,.72,0v0C63.62,62,82.71,60.5,88.4,49.92,93.41,40.58,83.51,33,83.51,33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M83.51,33C84.62,11.83,75,4.16,66.7,1.44c5,4,16.26,9.53,14.36,32.16,0,0,11,7.92,4.41,20.08a15.06,15.06,0,0,0,2.93-3.77C93.41,40.58,83.51,33,83.51,33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M47.43,32.61A2.35,2.35,0,1,1,45.1,30,2.5,2.5,0,0,1,47.43,32.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M44.3,30.55a2.14,2.14,0,0,0-.84.18,2.81,2.81,0,0,0-.7,1.88,2.5,2.5,0,0,0,2.33,2.63,2,2,0,0,0,.85-.18,2.79,2.79,0,0,0,.69-1.87A2.5,2.5,0,0,0,44.3,30.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M72,32.61A2.35,2.35,0,1,1,69.71,30,2.49,2.49,0,0,1,72,32.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M68.92,30.55a2.23,2.23,0,0,0-.85.18,2.85,2.85,0,0,0-.69,1.88,2.49,2.49,0,0,0,2.33,2.63,2,2,0,0,0,.85-.18,2.79,2.79,0,0,0,.69-1.87A2.5,2.5,0,0,0,68.92,30.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M71.23,31.84a.89.89,0,1,1-.89-.89A.88.88,0,0,1,71.23,31.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M46.64,31.84a.89.89,0,0,1-1.77,0,.89.89,0,1,1,1.77,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M76.1,70.58s0,.29.12.82"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M49.38,38.85s-7.13,6.54-10,20.4c0,0,7,2.45,11.44,2.4S49.38,38.85,49.38,38.85Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M39.42,59.25s3.49,24.32,27.28,25c9.15.24,15.54-2.43,18.61-6C90.12,72.65,49.84,62.3,49.84,62.3Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M101,57.92c-1.54-2-5.1.86-5.1.86s-1.09-3.9-3.56-3.09c-1.91.62-.61,3.46.07,4.7-1.05,1.93-7.14,12-18.15,7.33C65.12,63.83,75.7,50.41,63.82,37.8H49.49s-10.28,11-4.39,27.63,28.12,20.86,39.47,13.3c10.4-6.94,13.29-15,13.7-16.25C99.67,61.87,102.78,60.18,101,57.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M101.18,58.14l-.16-.22c-1.54-2-5.1.86-5.1.86s-1.09-3.9-3.56-3.1c-1.91.63-.61,3.47.07,4.71-1.05,1.93-7.14,12-18.15,7.33-8.9-3.78.85-16.57-9.53-28.87,2.42,3.46,4.62,13.06,2.93,20.45A10.7,10.7,0,0,0,82.52,71.49C92,67.61,94.08,60.75,94.08,60.75s-1.75-3.11-.78-3.91,2.61,3.23,2.61,3.23S98.25,57.09,101.18,58.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M40.21,42.9A3.88,3.88,0,1,1,36.33,39,3.88,3.88,0,0,1,40.21,42.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M81.06,42.9A3.88,3.88,0,1,1,77.18,39,3.88,3.88,0,0,1,81.06,42.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M101.85,2.23a20.21,20.21,0,0,0-6-1.13c6,1.13,14.86,6.42,17.13,18.45C116,35,108.85,48.08,99.9,53A19,19,0,0,0,106,49.46C119.88,37.53,117,7.42,101.85,2.23Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElephant);
export default __webpack_public_path__ + "static/media/elephant.cb68c7513b36ed90a571446b9be198f2.svg";
export { ForwardRef as ReactComponent };